import React from 'react';

type onBack = (() => () => void) | null;

type AuthLayoutContextValues = {
    pageTitle: string;
    onBack: onBack;
    setPageTitle: (state: string | ((state: string) => string)) => void;
    setBack: (state: onBack | ((state: onBack) => onBack)) => void;
};

type AuthLayoutProviderProps = {
    pageTitle: string;
    children: React.ReactNode;
};

const AuthLayoutContext = React.createContext<AuthLayoutContextValues | undefined>(undefined);

const AuthLayoutProvider = (props: AuthLayoutProviderProps): React.ReactElement => {
    const { pageTitle: pageTitleProps, children } = props;

    const [pageTitle, setPageTitle] =
        React.useState<AuthLayoutContextValues['pageTitle']>(pageTitleProps);

    const [onBack, setBack] = React.useState<AuthLayoutContextValues['onBack']>(null);

    React.useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    return (
        <AuthLayoutContext.Provider
            value={{
                pageTitle,
                onBack,
                setPageTitle,
                setBack,
            }}
        >
            {children}
        </AuthLayoutContext.Provider>
    );
};

const useAuthLayout = (): AuthLayoutContextValues => {
    const context = React.useContext(AuthLayoutContext);

    if (context === undefined) {
        throw new Error('auth layout context value are undefined');
    }

    return context;
};

export { AuthLayoutContext, AuthLayoutProvider, useAuthLayout };
